/** 숫자만 남기고 최대 max 자리로 자른다. */
export function digits(value: string, max: number): string {
  return value.replace(/\D/g, '').slice(0, max)
}

/** 카드 번호 raw(16자리) → 4자리마다 공백 ("8555 5555 5588 8888") */
export function formatCardNumber(raw: string): string {
  return raw.replace(/(.{4})/g, '$1 ').trim()
}

/** 유효기간 month/year → "MM/YY" | "MM" | "" (카드 프리뷰·입력값 공용) */
export function formatExpiry(month: string, year: string): string {
  if (!month && !year) return ''
  return year ? `${month}/${year}` : month
}
